// lotteryUtils.js
'use strict';

/**
 * Returns true with the given probability, otherwise false.
 *
 * @param {Object} [options] - Options object.
 * @param {number} [options.probability=0] - Probability of returning true (between 0 and 100).
 * @returns {boolean} - True with the specified probability, false otherwise.
 */
export const drawOne = ({ probability = 0 } = {}) => {
  if (typeof probability !== 'number' || probability < 0 || probability > 100) {
    return false;
  }
  return Math.random() * 100 < probability;
};
